<template>
  <div v-show="hayDatosSesion">
    <div class="row mb-3">
      <div class="col">
        <h2>Dedicacions personals</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="row mb-3">
          <div class="col">
            <h3>Darrer mes</h3>
          </div>
        </div>
        <div class="row mb-4">
          <div v-if="loaded.propios" class="col" ref="columnaPrincipal">
            <template v-if="Object.keys(chartData).length > 0">
              <Doughnut :chart-options="chartOptions" :chart-data="chartData" :styles="chartStyles" :plugins="chartPlugins" />
            </template>
            <template v-else>
              <p class="my-5">No hi ha dades disponibles.</p>
            </template>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="row mb-3">
          <div class="col">
            <h3>Enguany</h3>
          </div>
        </div>
        <div class="row mb-4">
          <div v-if="loaded.propios" class="col" ref="columnaAnual">
            <template v-if="Object.keys(chartAnualData).length > 0">
              <Doughnut :chart-options="chartAnualOptions" :chart-data="chartAnualData" :styles="chartAnualStyles" :plugins="chartPlugins" />
            </template>
            <template v-else>
              <p class="my-5">No hi ha dades disponibles.</p>
            </template>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!loading.proyectos">
      <div class="row mb-3">
        <div class="col">
          <h2>{{ tituloSeguimiento }}</h2>
        </div>
      </div>
      <slot></slot>
      <div class="btn-group btn-group-toggle btn-group-sm mb-3" data-toggle="buttons">
        <label class="btn btn-outline-primary" :class="{ 'active': tipoVista == 'grafica' }" title="Vista gràfica" v-tooltip>
          <input type="radio" name="options" v-model="tipoVista" value="grafica">
          <i class="fa-solid fa-chart-pie"></i>
        </label>
        <label class="btn btn-outline-primary" :class="{ 'active': tipoVista == 'simplificada' }" title="Vista horitzontal" v-tooltip>
          <input type="radio" name="options" v-model="tipoVista" value="simplificada">
          <i class="fa-solid fa-list"></i>
        </label>
        <label class="btn btn-outline-primary" :class="{ 'active': tipoVista == 'timeline' }" title="Vista timeline" v-tooltip>
          <input type="radio" name="options" v-model="tipoVista" value="timeline">
          <i class="fa-solid fa-timeline fa-rotate-90"></i>
        </label>
      </div>
      <div v-if="tipoVista == 'timeline'" class="ml-md-5 pl-md-5">
        <vue-timeline-update v-for="(item, index) in proyectosOrdenados" :key="`${item.id}-timeline`" :date="new Date(item.data_limit)" :dateString="item.data_limit ? formatearFecha(item.data_limit) : 'Sense data'" :title="item.cliente" :color="item.data_limit ? isPast(item.data_limit) ? 'red' : 'green' : 'orange'" icon="brightness_1" :class="`peligrosidad-${calcularPeligrosidad(item)}`" :is-last="index === proyectosOrdenados.length - 1">
          <div class="d-flex align-items-end d-flex justify-content-start" :class="{ 'float-left mr-3 mt-1': esVistaTimeline }">
            <router-link :to="{ path: '/recursos-projecte', query: { id: item.id, filtre: item.filtre ? item.filtre : 'tot' } }" class="text-primary font-weight-bold">{{ item.titol }}</router-link>
          </div>
          <estadistica-proyecto :responsable="item.trabajador_responsable" :prevision="item.prevision" :class="{ 'd-flex align-items-center ml-3': esVistaSimplificada && !esVistaTimeline }" :esVistaSimplificada="true" :esVistaTimeline="esVistaTimeline" :id="item.id"></estadistica-proyecto>
          <div class="collapsible collapse" :data-collapse="item.id">
            <BtnFiltroProyecto v-if="esGranted && !esVistaSimplificada" :item="item" :index="index" :loading="loading" :esVistaSimplificada="esVistaSimplificada" @cambiarFiltro="cambiarFiltro" class="mt-3">
              <button class="btn btn-outline-secondary btn-sm mt-1" data-toggle="modal" :data-target="`#modal-eliminar-${item.id}`" :class="{ disabled: loading.proyectosGestion[index] }" :disabled="loading.proyectosGestion[index]"><i class="fa-solid fa-circle-minus"></i> Treure projecte</button>
            </BtnFiltroProyecto>
            <ModalEliminarProyecto v-if="esGranted" :ref="`modalRetirar${item.id}`" :item="item" :index="index" :tituloSeguimiento="tituloSeguimiento" :loading="loading" @retirarProyecto="retirarProyecto" :trabajador="trabajador" />
          </div>
        </vue-timeline-update>
        <KPIProyectoNuevo @incluirProyecto="incluirProyecto" :esVistaGrafica="esVistaGrafica" :esGranted="esGranted" :posibles="posibles" :trabajador="trabajador" />
      </div>
      <div v-else>
        <draggable class="row" :class="{ 'overflow-auto d-grid d-xl-flex': esVistaSimplificada }" :list="proyectos" ghost-class="ghost" @start="ordenando = true" @end="ordenando = false" handle=".draggable-handler" :disabled="loading.orden">
          <template v-if="proyectos.length">
            <div v-for="(item, index) in proyectos" :key="`${item.id}-notimeline`" class="col-12 mb-3" :class="esVistaSimplificada ? 'kpi d-flex' : 'col-sm-6 col-lg-3 rounded-sm'" ref="columnaProyecto">
              <div class="px-5 px-sm-0" :class="{ 'd-flex align-items-center flex-grow-1 border-top pt-3': esVistaSimplificada }">
                <estadistica-proyecto :responsable="item.trabajador_responsable" :prevision="item.prevision" :class="{ 'd-flex align-items-center flex-row-reverse': esVistaSimplificada }" :esVistaSimplificada="esVistaSimplificada">
                  <BtnFiltroProyecto v-if="esGranted && !esVistaSimplificada" :item="item" :index="index" :loading="loading" :esVistaSimplificada="esVistaSimplificada" @cambiarFiltro="cambiarFiltro">
                    <div class="btn-group btn-group-sm mt-1" role="group" aria-label="Altres gestions">
                      <button class="btn btn-outline-secondary draggable-handler" title="Canviar ordre" ref="proyectosOrdenar" :class="{ disabled: loading.proyectosGestion[index] || loading.orden }" :disabled="loading.proyectosGestion[index] || loading.orden" v-tooltip><i class="fa-solid fa-up-down-left-right"></i></button>
                      <BtnEliminarProyecto ref="proyectosEliminar" :item="item" :index="index" :loading="loading" />
                    </div>
                  </BtnFiltroProyecto>
                  <div v-else-if="!esGranted && !esVistaSimplificada" :class="{ 'mr-1': esVistaSimplificada }">
                    <span class="badge badge-dark" title="Filtre en les dades" v-tooltip>{{ item.file ? item.file : "Tot" }}</span>
                  </div>
                  <div v-if="esVistaSimplificada" class="w-100 text-left mr-2">
                    <div class="h6 mb-0">{{ item.cliente }}</div>
                    <div class="align-items-center d-flex">
                      <router-link :to="{ path: '/recursos-projecte', query: { id: item.id, filtre: item.filtre ? item.filtre : 'tot' } }" class="h6 mb-0 text-truncate" :style="{ 'max-width': '345px' }">{{ item.titol }}</router-link>
                    </div>
                  </div>
                  <router-link v-else :to="{ path: '/recursos-projecte', query: { id: item.id, filtre: item.filtre ? item.filtre : 'tot' } }" class="h5">{{ item.titol }}</router-link>
                  <header :class="{ 'd-none': esVistaSimplificada }">{{ item.cliente }}</header>
                  <button v-if="item.directori" class="btn btn-link p-0" :class="esVistaSimplificada ? 'd-none' : 'd-block mx-auto'">
                    <presupuesto :codigo="item.codi_pressupost" :directorio="item.directori" />
                  </button>
                  <div v-else-if="item.codi_pressupost" :class="{ 'd-none': esVistaSimplificada }">{{ item.codi_pressupost }}</div>
                  <ModalEliminarProyecto :ref="`modalRetirar${item.id}`" :item="item" :index="index" :tituloSeguimiento="tituloSeguimiento" :loading="loading" @retirarProyecto="retirarProyecto" :trabajador="trabajador" />
                </estadistica-proyecto>
                <BtnFiltroProyecto v-if="esGranted && esVistaSimplificada" :item="item" :index="index" :loading="loading" :esVistaSimplificada="esVistaSimplificada" @cambiarFiltro="cambiarFiltro">
                  <div class="btn-group btn-group-sm" role="group" aria-label="Altres gestions">
                    <button class="btn btn-outline-secondary draggable-handler" title="Canviar ordre" ref="proyectosOrdenar" :class="{ disabled: loading.proyectosGestion[index] || loading.orden }" :disabled="loading.proyectosGestion[index] || loading.orden" v-tooltip><i class="fa-solid fa-up-down-left-right"></i></button>
                    <BtnEliminarProyecto ref="proyectosEliminar" :item="item" :index="index" :loading="loading" />
                  </div>
                </BtnFiltroProyecto>
                <div v-else-if="!esGranted && esVistaSimplificada" :class="{ 'mr-1': esVistaSimplificada }">
                  <span class="badge badge-dark" title="Filtre en les dades" v-tooltip>{{ item.file ? item.file : "Tot" }}</span>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="col-12">
              <p class="my-5">No hi ha dades disponibles.</p>
            </div>
          </template>
          <KPIProyectoNuevo @incluirProyecto="incluirProyecto" :esVistaGrafica="esVistaGrafica" :esGranted="esGranted" :posibles="posibles" :trabajador="trabajador" />
        </draggable>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.hover-light:hover {
  background-color: var(--light);
}

.ghost {
  opacity: 0.5;
  background: var(--light);
}

.kpi:first-child > :first-child {
  border-top: none !important;
}

.left-0 {
  left: 0;
}

.d-grid {
  display: grid;
}
</style>

<style lang="scss">
.gb-vue-timeline-update {
  .gb-vue-timeline-update__ago {
    font-weight: bold !important;
  }

  &:has(.gb-vue-timeline-update__bullet.gb-base-number--red) {
    .gb-vue-timeline-update__ago {
      border-color: var(--gray) !important;
      color: var(--gray) !important;
    }

    .gb-vue-timeline-update__line {
      background-color: var(--gray) !important;
    }
  }

  &:has(.gb-vue-timeline-update__bullet.gb-base-number--orange) {
    .gb-vue-timeline-update__ago {
      border-color: var(--secondary) !important;
      color: var(--secondary) !important;
    }

    .gb-vue-timeline-update__line {
      background-color: var(--secondary) !important;
    }
  }

  &:has(.gb-vue-timeline-update__bullet.gb-base-number--green) {

    .gb-vue-timeline-update__ago {
      border-color: var(--primary) !important;
      color: var(--primary) !important;
    }

    .gb-vue-timeline-update__line {
      background-color: var(--primary) !important;
    }
  }

  .gb-vue-timeline-update__line {
    width: 2px !important;
  }

  .gb-vue-timeline-update__title {
    font-size: inherit !important;
  }

  .gb-vue-timeline-update__slot {
    margin-top: 0 !important;

    a {
      text-decoration: inherit !important;

      &:hover {
        text-decoration: underline !important;
      }
    }
  }

  .gb-vue-timeline-update__bullet {
    &.gb-base-number--red {
      border-color: var(--gray) !important;
      color: var(--gray) !important;
    }

    &.gb-base-number--orange {
      border-color: var(--secondary) !important;
      color: var(--secondary) !important;
    }

    &.gb-base-number--green {
      border-color: var(--primary) !important;
      color: var(--primary) !important;
    }

  }

  &.peligrosidad-success .gb-vue-timeline-update__bullet i {
    color: var(--success) !important;
  }

  &.peligrosidad-warning .gb-vue-timeline-update__bullet i {
    color: var(--warning) !important;
  }

  &.peligrosidad-orange .gb-vue-timeline-update__bullet i {
    color: var(--orange) !important;
  }

  &.peligrosidad-danger .gb-vue-timeline-update__bullet i {
    color: var(--danger) !important;
  }
}
</style>

<script>
import draggable from "vuedraggable";
import { Doughnut } from "vue-chartjs/legacy";

import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale, Chart } from "chart.js";
import EstadisticaProyecto from "./EstadisticaProyecto.vue";
import Presupuesto from "./Presupuesto.vue";
import KPIProyectoNuevo from "./KPI/KPIProyectoNuevo.vue";
import BtnEliminarProyecto from "./KPI/BtnEliminarProyecto.vue";
import ModalEliminarProyecto from "./KPI/ModalEliminarProyecto.vue";
import BtnFiltroProyecto from "./KPI/BtnFiltroProyecto.vue";
import { obtenerNivelPeligrosidadRecursos } from "@/utils/projectStats";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

export default {
  name: "EstadisticaTrabajador",
  inject: ["colors", "formatearDecimales", "getTonoRandom", "formatearFecha"],
  props: {
    trabajador: Number,
    esFiltrado: Number,
    rango_inicio: String,
    rango_fin: String,
  },
  components: {
    Doughnut,
    EstadisticaProyecto,
    draggable,
    Presupuesto,
    KPIProyectoNuevo,
    BtnEliminarProyecto,
    ModalEliminarProyecto,
    BtnFiltroProyecto,
  },
  data() {
    return {
      ordenando: false,
      loaded: {
        propios: false,
      },
      loading: {
        proyectos: true,
        proyectosGestion: [],
        orden: false,
      },
      width: 400,
      height: 400,
      chartData: {},
      chartAnualData: {},
      proyectos: [],
      chartOptions: {
        layout: {
          padding: {
            bottom: 33, // lo que ocuparía la leyenda
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.label;
              },
            },
          },
          textoPrincipal: {
            sufijo: "h",
            fontSizeRelativa: 150,
          },
        },
      },
      chartAnualOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom",
            onHover: function (e) {
              e.native.target.style.cursor = "pointer";
            },
            onLeave: function (e) {
              e.native.target.style.cursor = "default";
            },
          },
          tooltip: {
            callbacks: {
              label(context) {
                const chart = context.chart;
                const visibles = chart.legend.legendItems.filter((a) => !a.hidden).map((a) => a.index);
                const valores = chart.data.datasets[0].data.filter((a, index) => visibles.includes(index));
                const total = valores.length ? Math.round(valores.reduce((prev, now) => parseFloat(prev ?? 0) + parseFloat(now))) : 0;

                return `${context.label}: ${Math.round(context.raw)}${context.dataset.label} (${Math.round((context.raw * 100) / total)}%)`;
              },
            },
          },
          textoPrincipal: {
            sufijo: "h",
            fontSizeRelativa: 150,
          },
        },
      },
      chartPlugins: [
        {
          id: "textoPrincipal",
          beforeDraw: (chart, args, options) => {
            const visibles = chart.legend.legendItems.filter((a) => !a.hidden).map((a) => a.index);
            const valores = chart.data.datasets[0].data.filter((a, index) => visibles.includes(index));
            const text = `${valores.length ? Math.round(valores.reduce((prev, now) => parseFloat(prev ?? 0) + parseFloat(now))) : 0}${options.sufijo ?? ""}`;

            this.ponerTextoPrincipal(chart, args, options, text);
          },
        },
      ],
      posibles: [],
      tituloSeguimiento: "Projectes en seguiment",
      usuarioRol: null,
      hayDatosSesion: null,
      tipoVista: "simplificada",
    };
  },
  computed: {
    esVistaSimplificada() {
      return this.tipoVista == "simplificada";
    },
    esVistaGrafica() {
      return this.tipoVista == "grafica";
    },
    esVistaTimeline() {
      return this.tipoVista == "timeline";
    },
    proyectosOrdenados() {
      return [...this.proyectos].sort((a, b) => new Date(a.data_limit) - new Date(b.data_limit));
    },
    chartStyles() {
      return {
        position: "relative",
      };
    },
    chartAnualStyles() {
      return {
        position: "relative",
      };
    },
    esGranted() {
      return this.trabajador && !(["super", "responsable"].includes(this.usuarioRol)) ? localStorage.getItem("usuarioTrabajador") == this.trabajador : true;
    },
  },
  created() {
    this.hayDatosSesion = localStorage.getItem("usuarioRol") !== null && localStorage.getItem("usuarioTrabajador") !== null;

    if (!this.hayDatosSesion) {
      this.$auth = false;

      return;
    }

    this.usuarioRol = localStorage.getItem("usuarioRol");
  },
  mounted() {
    if (!this.hayDatosSesion) return;

    this.$http.get("api/usuaris?login").then((response) => this.getData());
  },
  methods: {
    isPast(date) {
      return new Date(date) < new Date();
    },
    calcularPeligrosidad(item) {
      return obtenerNivelPeligrosidadRecursos(item.prevision);
    },
    getData: function () {
      const personal = { resumen_personal: true };

      if (this.trabajador) {
        personal.trabajador = this.trabajador;
      }

      this.$http.get(`api/dedicacions?${new URLSearchParams(personal)}`).then((response) => {
        if (response.data.recientes_personales) {
          const proyectos = response.data.recientes_personales.filter((a) => a.es_importante);
          const otros = response.data.recientes_personales.filter((a) => !a.es_importante);

          proyectos.push({
            proyecto: "Altres",
            tiempo_parcial: otros.reduce((previous, current) => previous + parseFloat(current.tiempo_parcial), 0),
          });

          const total = proyectos.reduce((previous, current) => previous + parseFloat(current.tiempo_parcial), 0);

          this.chartData = {
            labels: proyectos.map((a) => {
              const labels = [`${a.proyecto}:`, `${Math.round(a.tiempo_parcial)}h (${Math.round((a.tiempo_parcial * 100) / total)}%)`];

              if (a.cliente) {
                labels.unshift(a.cliente);
              }

              return labels;
            }),
            datasets: [
              {
                backgroundColor: proyectos.map((a) => `rgb(${[this.getTonoRandom(), this.getTonoRandom(), this.getTonoRandom()].join(",")})`),
                data: proyectos.map((a) => a.tiempo_parcial),
                label: "h",
              },
            ],
          };
        }

        if (response.data.anual) {
          this.chartAnualData = {
            labels: response.data.anual.map((a) => a.tipus),
            datasets: [
              {
                backgroundColor: [this.colors.primary, this.colors.secondary, this.colors.tertiary],
                data: response.data.anual.map((a) => a.total),
                label: "h",
              },
            ],
          };
        }

        this.loaded.propios = true;
      });

      this.getProyectos();
      this.getPosibles();
    },
    getPosibles() {
      const posibles = { order: "cliente" };

      this.$http.get(`api/projectes?activos&${new URLSearchParams(posibles)}`).then((response) => {
        const proyectos = this.proyectos.map((a) => a.id);

        this.posibles = response.data.filter((a) => !proyectos.includes(a.id));
      });
    },
    getProyectos() {
      const prevision = { resumen_prevision: true };

      if (this.trabajador) {
        prevision.trabajador = this.trabajador;
      }

      if (this.rango_inicio) {
        prevision.fecha_inicio = this.rango_inicio;
      }

      if (this.rango_fin) {
        prevision.fecha_fin = this.rango_fin;
      }

      this.$http.get(`api/projectes?${new URLSearchParams(prevision)}`).then((response) => {
        this.proyectos = response.data;

        this.loading.proyectos = false;
      });
    },
    ponerTextoPrincipal: function (chart, args, options, text) {
      const width = chart.chartArea.width;
      const height = chart.chartArea.height;
      const ctx = chart.ctx;

      ctx.restore();
      const fontSize = (height / (options.fontSizeRelativa ?? 200)).toFixed(2);
      ctx.font = fontSize + "em sans-serif";
      ctx.textBaseline = "middle";

      const textX = Math.round((width - ctx.measureText(text).width) / 2);
      const textY = chart.chartArea.top + height / 2;

      ctx.fillText(text, textX, textY);
      ctx.save();
    },
    cambiarFiltro(item, index) {
      this.$set(this.loading.proyectosGestion, index, true);

      this.$http
        .put("api/kpis", { id_projecte: item.id, es_visible: true, filtre: item.filtre, id_treballador: this.trabajador })
        .then((response) => {
          if (![200, 201].includes(response.status)) return;

          this.getProyectos();
        })
        .finally(() => this.$set(this.loading.proyectosGestion, index, false));
    },
    incluirProyecto(idProyecto) {
      this.getProyectos();

      this.posibles = this.posibles.filter((a) => a.id != idProyecto);
    },
    retirarProyecto(id_projecte, index) {
      this.$refs[`modalRetirar${id_projecte}`][0].cerrar();

      $(this.$refs.proyectosEliminar[index]).tooltip("dispose");

      this.proyectos = this.proyectos.filter((a) => a.id != id_projecte);

      this.getPosibles();
    },
  },
  watch: {
    trabajador: function (value) {
      this.getData();
    },
    esFiltrado: function (value) {
      this.getData();
    },
    proyectos(value) {
      const proyectos = value.map((a) => a.id);

      this.posibles = this.posibles.filter((a) => !proyectos.includes(a.id));
    },
    ordenando(value) {
      if (value) return;

      this.loading.orden = true;

      this.$refs.proyectosOrdenar.forEach((a) => $(a).tooltip("hide"));

      this.$http
        .put("api/kpis", { proyectos: this.proyectos, id_treballador: this.trabajador })
        .then((response) => {
          this.getProyectos();
        })
        .finally(() => (this.loading.orden = false));
    },
  },
};
</script>